import React, { useLayoutEffect, useRef, useState } from "react"
import "./OrdersTableScroll.css"

/**
 * Horizontal table scroller: the bottom bar stays visible.
 * A matching bar above the table appears only while the table is hovered.
 */
const OrdersTableScroll = ({ children }) => {
  const topRef = useRef(null)
  const bottomRef = useRef(null)
  const syncingRef = useRef(false)
  const [contentWidth, setContentWidth] = useState(0)
  const [overflowing, setOverflowing] = useState(false)

  useLayoutEffect(() => {
    const bottom = bottomRef.current
    if (!bottom) return undefined

    const measure = () => {
      const width = bottom.scrollWidth
      const canScroll = width - bottom.clientWidth > 1
      setContentWidth(width)
      setOverflowing(canScroll)
      const top = topRef.current
      if (top && top.scrollLeft !== bottom.scrollLeft) {
        syncingRef.current = true
        top.scrollLeft = bottom.scrollLeft
        syncingRef.current = false
      }
    }

    measure()
    const observer = new ResizeObserver(measure)
    observer.observe(bottom)
    const table = bottom.querySelector("table")
    if (table) observer.observe(table)

    return () => observer.disconnect()
  }, [children])

  const syncScroll = source => {
    if (syncingRef.current) return
    const top = topRef.current
    const bottom = bottomRef.current
    if (!top || !bottom) return
    const from = source === "top" ? top : bottom
    const to = source === "top" ? bottom : top
    if (to.scrollLeft === from.scrollLeft) return
    syncingRef.current = true
    to.scrollLeft = from.scrollLeft
    syncingRef.current = false
  }

  return (
    <div className="orders-table-scroll">
      <div
        ref={topRef}
        className={
          overflowing
            ? "orders-table-scroll__top orders-table-scroll__top--active"
            : "orders-table-scroll__top"
        }
        onScroll={() => syncScroll("top")}
        aria-hidden="true"
      >
        <div style={{ width: contentWidth, height: 1 }} />
      </div>
      <div
        ref={bottomRef}
        className="table-responsive"
        onScroll={() => syncScroll("bottom")}
      >
        {children}
      </div>
    </div>
  )
}

export default OrdersTableScroll
